/* =============================================================
   ST Akkordeon + Media
   Duennes Custom Element. Lauscht auf das bubbelnde `toggle`-Event,
   das die Concept-Accordion-Items (details[is="accordion-details"])
   bereits feuern, und synchronisiert das aktive Media-Panel rechts.

   Repliziert das Single-Open-Verhalten von <accordions-details>
   (schliesst andere Items) BEWUSST OHNE den window.scrollTo-Sprung,
   der bei einem Desktop-Zweispalter stoeren wuerde.
   ============================================================= */
if (!customElements.get('st-accordion-media')) {
  class StAccordionMedia extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('details[data-acc-index]'));
      this.panels = Array.from(this.querySelectorAll('[data-acc-panel]'));
      this.addEventListener('toggle', this.onToggle.bind(this));
      // ST 2026-10-25 (Wrike 4580939861): optionale Item-Videos. Nur das Video des offenen Items bzw. des aktiven
      // Panels darf spielen (die Panels liegen gestapelt uebereinander, alle gelten fuer den Browser als sichtbar).
      // vm.paused = true haelt das In-View-Autoplay aus theme.js an (wie im Feature-Slider, D-77).
      if (this.querySelector('video-media')) this.syncVideos();
    }

    syncVideos() {
      const openItem = this.items.find((item) => item.open);
      const index = openItem ? openItem.dataset.accIndex : null;
      this.querySelectorAll('video-media').forEach((media) => {
        const holder = media.closest('[data-acc-panel], details[data-acc-index]');
        const key = holder ? holder.dataset.accPanel ?? holder.dataset.accIndex : null;
        const active = key !== null && key === index;
        if (active) {
          if (media.paused) {
            media.paused = false;
            if (media.autoplayArmed && media.getBoundingClientRect().height > 0) media.play();
          }
        }
        else {
          // Erst pausieren, dann sperren: so bricht theme.js (stopLoading) einen laufenden Download ab.
          if (typeof media.pause === 'function') media.pause();
          media.paused = true;
        }
      });
    }

    onToggle(event) {
      const detail = event.detail || {};
      const current = detail.current;
      if (!current || !detail.open) return;

      // Single-Open: andere Items schliessen (ohne erneutes Dispatch -> kein Loop)
      this.items.forEach((item) => {
        if (item !== current && typeof item.close === 'function') item.close();
      });

      // Media synchronisieren
      const index = current.dataset.accIndex;
      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.accPanel === index);
      });

      if (this.querySelector('video-media')) this.syncVideos();
    }
  }

  customElements.define('st-accordion-media', StAccordionMedia);
}
